module.exports = __webpack_public_path__ + "static/media/switzerland.291460d3.svg";